// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"241":"login-widget","535":"login","897":"password-recovery"}[chunkId] + "." + {"241":"f7176d61","535":"f7176d61","897":"7a425c38"}[chunkId] + ".chunk.css";
};